import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Box } from '@/components/blocks/Box';
import { Overlay } from '@/components/blocks/Overlay';
import { Text } from '@/components/blocks/Text';

const Root = styled(Box)<{ $overlay?: boolean }>(({ $overlay }) =>
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    minHeight: $overlay ? '100%' : '200px',
    height: $overlay ? '100%' : 'auto',
  })
);

const Spinner = styled(Box)(({ theme }) =>
  css({
    width: '40px',
    height: '40px',
    border: `3px solid ${theme.colors.border.weak}`,
    borderTop: `3px solid ${theme.colors.border.primary}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: theme.spaces.m,
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },
  })
);

interface LoadingProps {
  message?: string;
  overlay?: boolean;
}

export const Loading = ({ message, overlay = false }: LoadingProps) => {
  const content = (
    <Root $overlay={overlay}>
      <Spinner />
      {message && <Text use='m-N'>{message}</Text>}
    </Root>
  );

  if (overlay) {
    return <Overlay open={true}>{content}</Overlay>;
  }

  return content;
};
